<template lang='pug'>
.articleStory-top(v-if="info.type === 'image' && info.thumbnailUrl !== ''")
  .articleStoryHead
    img.articleStoryHead-imagePosition(:src='info.thumbnailUrl')
  .articleStory-subdescription {{ "發表時間 " + time }}
.articleStory-top(v-else-if="info.type === 'image' && info.thumbnailUrl === ''")
  .articleStory-image(:style= 'defaultImg' )
  .articleStory-subdescription {{ "發表時間 " + time }}
.articleStory-top(v-else-if="info.type === 'audio' && info.sourceMedia && !audioError")
  .articleStory-audio-title 語音資訊內容(音頻經過變聲調整)
  .articleStory-audio
    audio(:src='info.sourceMedia' controls controlslist="nodownload noremoteplayback noplaybackrate" @error='handleAudioError' class="custom-audio")
  .articleStory-subdescription {{ "發表時間 " + time }}
.articleStory-top(v-else-if="info.type === 'audio' && audioError")
  .articleStory-audio-title 語音資訊內容(音頻經過變聲調整)
  .articleStory-audio-error {{ audioError }}
  .articleStory-subdescription {{ "發表時間 " + time }}
.articleStory-top(v-else)
  h3.articleStory-title {{ info.content }}
  .articleStory-subdescription {{ "發表時間 " + time }}
</template>

<script>
import { getCategoryImgURL } from '@/plugins/tool.js'
export default {
  props: {
    info: Object,
    staticData: Object
  },
  data(){
    return {
      defaultImg: "background-image: url('" + getCategoryImgURL("/fig-link.png") + "');",
      audioError: null
    }
  },
  methods: {
    handleAudioError(event) {
      switch (event.target.error.code) {
        case MediaError.MEDIA_ERR_NETWORK:
          this.audioError = '播放器發生暫時性的錯誤，請重新整理';
          break;
        case MediaError.MEDIA_ERR_ABORTED:
          break;
        case MediaError.MEDIA_ERR_DECODE:
          this.audioError = '音頻文件損壞或不支持，無法播放';
          break;
        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
          this.audioError = '您的瀏覽器不支援音訊播放器，請使用其他瀏覽器來聆聽。';
          break;
        default:
          this.audioError = '播放器發生暫時性的錯誤，請重新整理';
          break;
      }
    },
    clearAudioError() {
      this.audioError = null;
    }
  },
  computed: {
    time() {
      if (!this.info.createdAt) {
        return ''
      }
      var t = this.info.createdAt.split('T')
      var date = t[0].split('-').join('/')
      var time = t[1].substring(0, 5)
      return date + ' ' + time
    },
    url() {
      var lengthLimit = 50
      if (this.info.url && this.info.url.length > lengthLimit)
        return this.info.url.substring(0, lengthLimit) + "..."
      return this.info.url
    },
    isImg(){
      if(this.info.type === 'image'){
        return true
      }
      return false
    }
  }
}
</script>